import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  useEventCallback,
} from '@mui/material';
import { CivilUnionVM, ItalianVM, ForeignVM } from 'mutation/view-models/civil-union';
import { memo } from 'react';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import ChooseDate from 'shell/components/shared/choice-date';
import { DateTime } from 'luxon';
import { DatePickerView } from '@mui/lab/DatePicker/shared';
import Italian from './italian';
import Foreign from './foreign';
import { FormikErrors, FormikTouched } from 'formik';
import PmiDivider from 'shell/components/shared/divider';

interface CivilUnionFormProps {
  values?: CivilUnionVM | null;
  onChange: (key: keyof CivilUnionVM, value: CivilUnionVM[keyof CivilUnionVM]) => void;
  onChangeValues: (value: CivilUnionVM) => void;
  errors: FormikErrors<CivilUnionVM>;
  touched: FormikTouched<CivilUnionVM>;
  disabled?: boolean;
}

const DataMergeComponent = ({
  values,
  onChange,
  onChangeValues,
  errors,
  touched,
  disabled = false,
}: CivilUnionFormProps): React.ReactElement => {
  // Handle choice date
  const handleChooseDateChange = useEventCallback(
    (date: DateTime | null, choice?: Array<DatePickerView>) => {
      onChangeValues({
        ...values,
        dateEvent: date,
        dateEventChoice: choice,
      });
    }
  );

  const onChangeRadio = useEventCallback(() => {
    onChangeValues({
      ...values,
      isForeign: !values?.isForeign,
      // reset
      italian: null,
      foreign: null,
    });
  });

  const onChangeItalian = useEventCallback(
    (key: keyof ItalianVM, value: ItalianVM[keyof ItalianVM]) => {
      onChange('italian', {
        ...values?.italian,
        [key]: value,
      });
    }
  );

  const onChangeForeign = useEventCallback(
    (key: keyof ForeignVM, value: ForeignVM[keyof ForeignVM]) => {
      onChange('foreign', {
        ...values?.foreign,
        [key]: value,
      });
    }
  );

  return (
    <Grid item container spacing={1}>
      <Grid item xs={12}>
        <PmiTitleDivider>Dati unione</PmiTitleDivider>
      </Grid>
      <Grid item xs={12}>
        <PmiDivider />
      </Grid>
      <Grid item xs={12}>
        <ChooseDate
          selected={values?.dateEvent || null}
          onChange={handleChooseDateChange}
          choice={values?.dateEventChoice}
          required
          error={touched?.dateEvent && Boolean(errors?.dateEvent)}
          label="Data evento"
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControl
          component="fieldset" // disabled={disabled}
        >
          <RadioGroup
            row
            aria-label="Luogo evento"
            id="isForeign"
            value={values?.isForeign || 'false'}
            onChange={onChangeRadio}
          >
            <FormControlLabel value="false" control={<Radio />} label="Evento italia" />
            <FormControlLabel value="true" control={<Radio />} label="Evento stato estero" />
          </RadioGroup>
        </FormControl>
      </Grid>
      {values?.isForeign ? (
        <Foreign
          onChange={onChangeForeign}
          values={values?.foreign}
          errors={errors?.foreign as FormikErrors<ForeignVM>}
          touched={touched?.foreign as unknown as FormikTouched<ForeignVM>}
          // disabled={disabled}
        />
      ) : (
        <Italian
          onChange={onChangeItalian}
          values={values?.italian}
          errors={errors?.italian as FormikErrors<ItalianVM>}
          touched={touched?.italian as unknown as FormikTouched<ItalianVM>}
          // disabled={disabled}
          fromDate={values?.dateEvent}
        />
      )}
    </Grid>
  );
};

DataMergeComponent.displayName = 'Accordion Civil Union form - Data Merge';

const DataMerge = memo(DataMergeComponent);

export default DataMerge;
